import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var ErrorComponent = function (_super) {
  __extends(ErrorComponent, _super);

  function ErrorComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return {};
    }
  })], ErrorComponent.prototype, "data", void 0);

  ErrorComponent = __decorate([Component], ErrorComponent);
  return ErrorComponent;
}(Vue);

export default ErrorComponent;